import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { footerMessages } from './messages';
import styles from './styles.module.less';
import { ImportType } from '../../../../../../components/csv-import/data/types/import-type';
import { useImportContext } from '../../../../../../components/csv-import/ui/components/import-context';
import { useCsvImport } from '../../../../../../components/csv-import/ui/hooks/use-csv-import';
import Global from '../../../../../../store/global-selectors';

/** @typedef {import("../../types").FooterProps<void>} FooterProps */

/**
 * @param {FooterProps} props
 * @returns {React.JSX.Element}
 */
export const Footer = ({ goToNext }) => {
  const latestImport = useSelector((state) => Global.selectCsvImportType(state, ImportType.fulfillmentProduct));

  const { open } = useCsvImport(ImportType.fulfillmentProduct);

  const { initImport, initRequest } = useImportContext();

  const onStartProcess = useCallback(() => {
    if (latestImport.status) {
      goToNext();
      return;
    }
    initImport(open);
  }, [goToNext, initImport, latestImport.status, open]);

  return (
    <Button
      className={styles.footer}
      disabled={!initRequest?.csvFile && !latestImport.status}
      onClick={onStartProcess}
      theme={THEME_CONSTANTS.primary}
    >
      <FormattedMessage {...footerMessages.continue} />
    </Button>
  );
};
